import React from 'react';

const EmailTemplate = ({ customContent }) => {
  // Default template if no custom content is provided
  const defaultTemplate = `
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif; color: #333333;">
      <!-- Header with Logo -->
      <tr>
        <td align="center" style="padding: 20px 0;">
          <table border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr>
              <td width="50%" align="left" style="padding-right: 20px;">
                <img src="cid:emailImage1" alt="Polymath Kids Logo" style="max-width: 150px; height: auto;" />
              </td>
              <td width="50%" align="right" style="padding-left: 20px;">
                <img src="cid:emailImage2" alt="Polymath Kids Logo" style="max-width: 80px; height: auto;" />
              </td>
            </tr>
          </table>
        </td>
      </tr>
      
      <!-- Tagline -->
      <tr>
        <td align="center" style="padding: 10px 20px;">
          <h2 style="margin: 0; color: #333; font-size: 24px; line-height: 1.4;">We upskill kids to help become <span style="color: #e91e63;">polymath</span></h2>
        </td>
      </tr>
      
      <!-- Skill Diamonds Diagram -->
      <tr>
        <td align="center" style="padding: 20px;">
          <img src="cid:emailImage3" alt="Polymath Skills Diagram" style="max-width: 100%; height: auto;" />
        </td>
      </tr>
      
      <!-- About Section -->
      <tr>
        <td style="padding: 20px; background-color: #f8f8f8; border-radius: 8px;">
          <p style="margin: 0 0 15px 0; line-height: 1.6;">
            Polymath-Kids is a global EdTech platform that aims to equip the next generation with STEM and essential 21st century life skills, including digital, numeracy, literacy, analytical, social, and entrepreneurial skills. This helps them identify their aptitude, personality, and interests and explore career ideas, which empowers children for success in the early stages and a smooth workforce transition.
          </p>
        </td>
      </tr>
      
      <!-- Tagline 2 -->
      <tr>
        <td align="center" style="padding: 30px 20px 20px 20px;">
          <h2 style="margin: 0; color: #333; font-size: 22px;">"We Upskill Kids to Help Become Polymath"</h2>
        </td>
      </tr>
      
      <!-- Services Description -->
      <tr>
        <td style="padding: 0 20px 20px 20px;">
          <p style="margin: 0 0 20px 0; line-height: 1.6; text-align: center;">
            Polymath-Kids is a global educational technology platform that offers a diverse range of courses (40+) designed to foster vital 21st-century life skills
          </p>
        </td>
      </tr>
      
      <!-- Course Features -->
      <tr>
        <td>
          <table border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr>
              <td align="center" width="25%" style="padding: 10px;">
                <img src="cid:emailImage4" alt="Project-Based Learning" style="width: 60px; height: auto;" />
                <p style="margin: 10px 0 0 0; font-size: 14px; text-align: center; font-weight: bold;">Project-Based Fun Learning</p>
              </td>
              <td align="center" width="25%" style="padding: 10px;">
                <img src="cid:emailImage5" alt="Online Live Classes" style="width: 60px; height: auto;" />
                <p style="margin: 10px 0 0 0; font-size: 14px; text-align: center; font-weight: bold;">Online Live Classes</p>
              </td>
              <td align="center" width="25%" style="padding: 10px;">
                <img src="cid:emailImage6" alt="Group & 1on1 Classes" style="width: 60px; height: auto;" />
                <p style="margin: 10px 0 0 0; font-size: 14px; text-align: center; font-weight: bold;">Group & 1on1 Classes</p>
              </td>
              <td align="center" width="25%" style="padding: 10px;">
                <img src="cid:emailImage7" alt="Activities & Projects" style="width: 60px; height: auto;" />
                <p style="margin: 10px 0 0 0; font-size: 14px; text-align: center; font-weight: bold;">Thousands Of Activities & Projects</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      
      <!-- Partnership Banner -->
      <div style="background-color: #6a1b9a;  color: white;">
      <tr>
        <td style="padding: 30px 0; background-color: #6a1b9a; color: white; text-align: center;">
          <p style="margin: 0; padding: 0 10px; font-size: 14px; line-height: 1.4;">
            Polymath-Kids partners with schools to equip their students with vital 21st century life skills & STEM education, ensuring a well-rounded education for future success.
          </p>
        </td>
      </tr>
      
      <!-- School Features -->
      <tr style="background-color: #6a1b9a;  color: white;">
        <td>
          <table border="0" cellpadding="0" cellspacing="0" width="100%" style=" padding: 20px 0;">
            <tr>
              <td align="center" width="20%" style="padding: 10px;">
                <img src="cid:emailImage8" alt="School Collaborations" style="width: 50px; height: auto;" />
                <p style="margin: 5px 0 0 0; font-size: 12px; text-align: center;">School Collaborations</p>
              </td>
              <td align="center" width="20%" style="padding: 10px;">
                <img src="cid:emailImage9" alt="Customized Courses" style="width: 50px; height: auto;" />
                <p style="margin: 5px 0 0 0; font-size: 12px; text-align: center;">Customized Courses</p>
              </td>
              <td align="center" width="20%" style="padding: 10px;">
                <img src="cid:emailImage10" alt="Age-appropriate curriculum" style="width: 50px; height: auto;" />
                <p style="margin: 5px 0 0 0; font-size: 12px; text-align: center;">Age-appropriate curriculum</p>
              </td>
              <td align="center" width="20%" style="padding: 10px;">
                <img src="cid:emailImage11" alt="Diverse Course Offerings" style="width: 50px; height: auto;" />
                <p style="margin: 5px 0 0 0; font-size: 12px; text-align: center;">Diverse Course Offerings</p>
              </td>
              <td align="center" width="20%" style="padding: 10px;">
                <img src="cid:emailImage12" alt="Expert Teachers" style="width: 50px; height: auto;" />
                <p style="margin: 5px 0 0 0; font-size: 12px; text-align: center;">Access to Subject Matter Expert Teachers</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      
      <!-- Invitation Text -->
      <tr style="background-color: #6a1b9a;  color: white;">
        <td style="padding: 30px 20px; text-align: center;">
          <p style="margin: 0; line-height: 1.6; font-size: 15px;">
            We would be delighted to discuss potential collaboration further and explore how Polymath-Kids can enhance your school's educational offerings. Please let us know your availability for a meeting or a call, and we can set up a convenient time to discuss this opportunity in more detail.
          </p>
        </td>
      </tr>
      
      <!-- Closing -->
      <tr style="background-color: #6a1b9a;  color: white;">
        <td style="padding: 0 20px 20px 20px; text-align: center;">
          <p style="margin: 0; font-size: 16px; font-weight: bold;">Warm regards, 😊</p>
        </td>
      </tr>
      
      <!-- Social Media Icons -->
      <tr style="background-color: #6a1b9a;  color: white;">
        <td align="center" style="padding: 0 0 20px 0;">
          <table border="0" cellpadding="0" cellspacing="0">
            <tr>
              <td style="padding: 0 10px;">
                <a href="https://www.facebook.com/polymathkidz" target="_blank">
                  <img src="cid:emailImage13" alt="Facebook" style="width: 32px; height: 32px;" />
                </a>
              </td>
              <td style="padding: 0 10px;">
                <a href="https://www.linkedin.com/company/polymath-kids" target="_blank">
                  <img src="cid:emailImage14" alt="LinkedIn" style="width: 32px; height: 32px;" />
                </a>
              </td>
              <td style="padding: 0 10px;">
                <a href="https://www.instagram.com/polymathkidz" target="_blank">
                  <img src="cid:emailImage15" alt="Instagram" style="width: 32px; height: 32px;" />
                </a>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      </div>
    </table>
  `;

  return customContent || defaultTemplate;
};

// Function to generate a complete email with any custom content
export const generateEmailTemplate = (customContent) => {
  const template = EmailTemplate({ customContent });

  return `
    <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html xmlns="http://www.w3.org/1999/xhtml">
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </head>
    <body style="margin: 0; padding: 0; background-color: #f5f5f5; font-family: Arial, sans-serif;">
      <div style="padding: 20px;">
        ${template}
      </div>
    </body>
    </html>
  `;
};

// Helper function to extract images from email body for attachments
export const extractImagesFromTemplate = (htmlContent) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const images = tempDiv.querySelectorAll('img');
  const attachments = [];

  // Define static images mapping
  const staticImages = {
    'cid:emailImage1': '/images/emailImage1.png',
    'cid:emailImage2': '/images/emailImage2.png',
    'cid:emailImage3': '/images/emailImage3.png',
    'cid:emailImage4': '/images/emailImage4.png',
    'cid:emailImage5': '/images/emailImage5.png',
    'cid:emailImage6': '/images/emailImage6.png',
    'cid:emailImage7': '/images/emailImage7.png',
    'cid:emailImage8': '/images/emailImage8.png',
    'cid:emailImage9': '/images/emailImage9.png',
    'cid:emailImage10': '/images/emailImage10.png',
    'cid:emailImage11': '/images/emailImage11.png',
    'cid:emailImage12': '/images/emailImage12.png',
    'cid:emailImage13': '/images/emailImage13.png',
    'cid:emailImage14': '/images/emailImage14.png',
    'cid:emailImage15': '/images/emailImage15.png', 
  };

  // Process each image
  images.forEach((img, index) => {
    const cid = `emailImage${index + 1}`;
    const staticPath = staticImages[`cid:${cid}`];

    if (staticPath) {
      // For static images, we'll need to fetch them and convert to base64
      attachments.push({
        filename: `emailImage${index + 1}.png`,
        path: staticPath,
        cid: cid,
        contentType: 'image/png',
        contentDisposition: 'inline'
      });
    } else if (img.src.startsWith('data:image')) {
      // Handle base64 images (for any additional images added through the editor)
      const base64Data = img.src.split(',')[1];
      const mimeType = img.src.split(';')[0].split(':')[1];
      const extension = mimeType.split('/')[1];
      const filename = `inline-image-${index + 1}.${extension}`;

      attachments.push({
        filename: filename,
        content: base64Data,
        encoding: 'base64',
        cid: cid,
        contentType: mimeType,
        contentDisposition: 'inline'
      });
    }
  });

  return {
    modifiedHtml: tempDiv.innerHTML,
    attachments: attachments
  };
};

export default EmailTemplate; 